<template>
    <ies-form-field :field="field">
        <div class="ies-switch">
            <v-switch hide-details
                    v-model="input"
                    :label="labelString"
                    :color="colorParsed"
                    v-on:change="updateField()"
                    :disabled="this.field.disabled">
            </v-switch>

            <!--hidden input with this field value, so we can access it from other component as v-switch will be rendered as div-->
            <input :name="this.field.fieldName" type="hidden" :value="input">
        </div>
    </ies-form-field>
</template>

<script>
    export default {
        name: 'ies-switch',
        props: ['field', 'color', 'label'],
        components: {
            'ies-form-field': require('./FormField.vue').default,
        },
        data () {
            return {
                input: (this.field.value == '1' ? 1 : 0),
                passedColor: this.color,
                defaultColor: 'lime',   // it's ies-green
            }
        },
        methods: {
            updateField: function(){
                this.field.value = this.input;
                this.emitCheckboxChange();
            },

            /**
             * Because vue renders v-switch as normal div, if we ever want to check this input value from outside of this component
             * and listen for that change - we need to use backup hidden input, but we need to manually trigger change event
             * when v-switch is being changed
             */
            emitCheckboxChange() {
                let search = "input[name='" + this.field.fieldName + "']";
                let input = $(search);
                input.change();
            },

        },
        computed: {
            /**
             * Decides what color apply to switch component
             * @returns {string}
             */
            colorParsed() {
                let color = this.defaultColor;
                let passed = this.passedColor;


                if (passed && (passed === 'switch' || passed === 'switch_green')) {
                    color = this.defaultColor;
                }
                else if (passed && passed.includes('switch_')) {
                    // color was send with switch string, we need to remove switch string
                    color = passed.replace('switch_','');
                }
                else if (passed) {
                    color = passed;
                }

                return color;
            },

            labelString() {
                if (this.label && this.label !== 'No') {
                    return this.input ? 'Yes' : 'No';
                }
                else {
                    return '';
                }
            }
        },
    }
</script>

<style>
    .ies-switch .input-group__details {
        display: none;
    }

</style>
